namespace SP {
    export interface Address {
        name: string;
        attention: string;
        street1: string;
        street2: string;
        zipcode: string;
        city: string;
        country: string;
        state: string;
        phone: string;
        email: string;
    }
}